// @see mylw-nxdev.nexcess-internal.workers.dev
import devTemplate from './dev';
import type { AppConfigI } from './example';

const nxdev: AppConfigI = {
	...devTemplate,
	hosts: {
		...devTemplate.hosts,
		www: 'dev-marketing.nexcess.com',
	},
	gaTrackerId: 'G-1TWF0K1664',
	gtmContainerId: 'GTM-P63QM29T',
	cart: {
		checkoutURL: 'https://dev-marketing.nexcess.com/cart/checkout',
		configURL: 'https://dev-marketing.nexcess.com/configuration',
		cookieDomain: 'nexcess.com',
		payPalSystem: 'portal_nx',
		payPalSignUpSystem: 'portal_signup_nx',
	},
	openId: {
		...devTemplate.openId,
		client_id: 'nx-portal',
		authority: 'https://login.dev.nexcess.com',
	},
	theme: 'nexcess',
	brand: 'nexcess',
};

export default nxdev;
